<template>
    <div id="heating-tube-overtemperature" style="width: 460px;height:270px;"></div>
</template>

<script>
  import {
    UserStore
  } from '@/utils/Mixin'
  const echarts = require('echarts')
  export default {
    mixins: [UserStore],
    data () {
      return {
        list: []
      }
    },
    watch: {
      Data (n) {
        this.getData()
      },
      list () {
        this.init()
      }
    },
    methods: {
      getData () {
        let list = []
        if (this.Data && this.Data.data4 && this.Data.data4.items1) {
          list = this.Data.data4.items1
        }
        this.list = list
      },
      init () {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('heating-tube-overtemperature'))

        let xAxisData = []
        let seriesData = []
        // 设备数
        let nums = []

        this.list.forEach((i, k) => {
          xAxisData.push(i.x || '')
          seriesData.push(i.y || 0)
          nums.push(i.device_num || 0)
        })

        // 指定图表的配置项和数据
        let option = {
          title: {
            subtext: '单位：次',
            subtextStyle: {
              // 文字颜色
              color: '#74a0bf',
              // 字体大小
              fontSize: 12
            }
          },
          grid: {
            x: '12%', // x 偏移量
            width: '80%', // 宽度
            height: '60%' // 高度
          },
          dataZoom: [ // 给x轴设置滚动条
            {
              start: 0, // 默认为0
              end: 100 - 1500 / 31, // 默认为100
              type: 'slider',
              // 显示滚动条
              show: false,
              xAxisIndex: [0],
              handleSize: 0, // 滑动条的 左右2个滑动条的大小
              height: 4, // 组件高度
              left: '10%', // 左边的距离
              right: '10%', // 右边的距离
              bottom: 18, // 右边的距离
              borderColor: '#000',
              fillerColor: '#01b3e4',
              borderRadius: 5,
              backgroundColor: '#33384b', // 两边未选中的滑动条区域的颜色
              showDataShadow: false, // 是否显示数据阴影 默认auto
              showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
              realtime: true, // 是否实时更新
              filterMode: 'filter'
            },
            // 下面这个属性是里面拖到
            {
              type: 'inside',
              show: true,
              xAxisIndex: [0],
              start: 0, // 默认为1
              end: 100 - 1500 / 31 // 默认为100
            }
          ],
          tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                // formatter: '{value}',
                backgroundColor: '#01b3e4'
              }
            },
            formatter: (params) => {
              return `
                ${params[0].axisValue}
                <br />
                ${params[0].marker}
                <span>${params[0].data}</span>
                <br />
                <span style="display: inline-block;margin-right: 4px;width: 10px;height: 10px;border-radius: 100%;background: #01b3e4;"></span>
                <span>设备数：${nums[params[0].dataIndex] || 0}</span>
                <br />
                `
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData,
            // 刻度
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#74a0bf', // 左边线的颜色
                width: '1' // 坐标线的宽度
              }
            },
            axisLabel: {
              textStyle: {
                // 坐标值得具体的颜色
                color: '#74a0bf',
                fontSize: 12
              }
            }
          },
          yAxis: {
            type: 'value',
            scale: false,
            minInterval: 100, // 分割刻度
            max: function (value) { // 取最大值向上取整为最大刻度
              return Math.ceil(value.max + 100)
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#74a0bf',
                width: '1'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#74a0bf',
                fontSize: 12
              }
            },
            splitLine: {
              show: true, // X网格线
              lineStyle: { // x网格线
                color: '#002d37'
              }
            }
          },
          series: [{
            data: seriesData,
            type: 'line',
            areaStyle: {
              opacity: 1,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(175, 57, 79,1)'
              }, {
                offset: 1,
                color: 'rgba(68, 36, 52,0.5)'
              }])
            },
            lineStyle: {
              color: '#f94762',
              width: 2
            },
            // 圆弧
            smooth: false,
            // 拐点
            symbol: 'none'
          }],
          showAllSymbol: 0
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
      }
    }
  }
</script>

<style lang="less">
    #heating-tube-overtemperature {
        box-sizing: border-box;
        margin: 0 auto;

    }
</style>
